// Polls API methods — mixin applied to the ApiService prototype chain.
// Methods run with `this` bound to the ApiService instance, so this.request()
// and cross-domain calls resolve through the shared HttpClient base.
const withPollsApi = (Base) => class extends Base {
  // Polls API
  async createPollSession(title, courseId = null, electiveId = null, expiresAt = null) {
    return this.request('/polls/sessions', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ title, courseId, electiveId, expiresAt })
    });
  }

  async getActivePollForStudent() {
    return this.request('/polls/student/active');
  }

  async listActivePollSessionsForStudent() {
    return this.request('/polls/student/active-sessions');
  }

  async submitPollAnswer(code, questionId, groupLabel, answerText, optionId = null, ratingValue = null) {
    return this.request('/polls/answer', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code, questionId, groupLabel, answerText, optionId, ratingValue })
    });
  }

  async votePollAnswer(answerId) {
    return this.request(`/polls/answers/${answerId}/vote`, { method: 'POST' });
  }

  async addPollQuestions(sessionId, questions) {
    return this.request('/polls/questions', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sessionId, questions })
    });
  }

  async activatePollQuestion(questionId) {
    return this.request(`/polls/activate/${questionId}`, { method: 'POST' });
  }

  async getPollState(code) {
    return this.request(`/polls/state/${code}`);
  }

  async listPollSessions() {
    return this.request('/polls/sessions');
  }

  async getPollSession(sessionId) {
    return this.request(`/polls/sessions/${sessionId}`);
  }

  async setPollGroups(sessionId, groups) {
    return this.request(`/polls/sessions/${sessionId}/groups`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ groups })
    });
  }

  async listActivePollSessions() {
    return this.request('/polls/active');
  }

  async updatePollSession(sessionId, payload) {
    return this.request(`/polls/sessions/${sessionId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  async deletePollSession(sessionId) {
    return this.request(`/polls/sessions/${sessionId}`, { method: 'DELETE' });
  }

  async updatePollQuestion(questionId, payload) {
    return this.request(`/polls/questions/${questionId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  async deletePollQuestion(questionId) {
    return this.request(`/polls/questions/${questionId}`, { method: 'DELETE' });
  }

};

export default withPollsApi;
